import React, { Component } from 'react';
import State from './State';
import List from './List';
import Hover from './Hover';

class PowerPlugin extends Component {
  render() {
    return (
      <>
        <p>It's a plugin which is used for re-usable components.
        </p>
        <section>
          <h3>State function renders</h3>
          this state runs child property, one at a time 
          <State initial={{ loading: false, data: null }}>
            {/* <h2>State renders</h2> */}
            {({ state, setState }) => {
              return <div>
              <h4>{JSON.stringify(state)}</h4>
              <button
              className="ui green button"
              onClick={() => setState({
                loading: !state.loading
              }) }>Toggle Loading</button>  
              </div>
            }}
          </State>
        </section>
<hr/>
        <section>
          <State initial={{ count: 0 }}>
            {({ state, setState }) => {
              return <div>
              <br/>
              <h3>State Counter function renders</h3>
              <h4>{JSON.stringify(state)}</h4>
              <button
              className="ui blue button"
              onClick={() => setState({
                count: state.count + 1
              }) }>Add Counter</button>  
              <button
              className="ui yellow button"
              onClick={() => setState({
                count: 0
              }) }>Reset Counter</button>  
              </div>
            }}
          </State>
        </section>
<hr/>
        <section>
          <br/>
          <h3>List Example</h3>
          <p>Add / Remove Items</p>
          <List initial={["Apples", "Banana"]}>
            {({ list, push, pull }) => (
              // <div>{JSON.stringify(list)}</div>
              <div>
                <form
                className="ui form"
                onSubmit={(e) => {
                  e.preventDefault();
                  push(this.textRef.value)
                  this.textRef.value = ""
                }}
                >
                  <div className="field" style={{display: "inline-flex"}}>
                    <input type="text"
                    ref={(node) => this.textRef = node}
                    />
                    <button
                    className="ui violet button"
                    type="submit"
                    >Add Items</button>
                  </div>
                </form>

                <div className="ui middle aligned selection list">
                {list.map((lst, id) => (
                  <div className="item" key={id}
                  onClick={() => {
                    pull((listItem, index) => {
                      return id === index
                    })
                  }}
                  >
                    <div className="content">
                      <div className="header">
                      <i className="angle double right icon"></i>
                        {lst}
                      </div>
                    </div>
                  </div>
                ))}
                </div>
              </div>
            )}
          </List>
        </section>
<hr/>
        <section>
          <br/>
          <Hover>
            {({ hovered, bind }) => (
              <section>
                <div {...bind}>
                  <button
                  className="ui button"
                  style={{
                    backgroundColor: hovered 
                                    ? "violet"
                                    : "yellow"
                  }}
                  >Hover Over Me</button>
                  {hovered ? "hovering" : "not hovering"}
                </div>
              </section>
            )}
          </Hover>
        </section>
      </>
    )
  }
}

export default PowerPlugin;
